module.exports = __webpack_public_path__ + "static/img/button12.3bb13c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button12.png
// module id = vjJv
// module chunks = 4